function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#C9DAE6",
  d: "M66.7,40.7H35c-5.1,0-9.3-4.2-9.3-9.3v0c0-5.1,4.2-9.3,9.3-9.3h31.7c5.1,0,9.3,4.2,9.3,9.3v0   C76,36.5,71.8,40.7,66.7,40.7z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#C9DAE6",
  d: "M167.9,67.7h-31.7c-5.1,0-9.3-4.2-9.3-9.3v0c0-5.1,4.2-9.3,9.3-9.3h31.7c5.1,0,9.3,4.2,9.3,9.3v0   C177.3,63.5,173.1,67.7,167.9,67.7z"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 60,
  y: 37.3,
  fill: "#FFFFFF",
  width: 87,
  height: 75
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  stroke: "#77A2BF",
  strokeWidth: 3,
  strokeMiterlimit: 10,
  d: "M62.5,111.9h85.6c6.6,0,12-5.4,12-12V48c0-3.3-2.7-6-6-6H79.5c-3.3,0-6,2.7-6,6l0.2,53.3   c0,5.8-4.7,10.6-10.6,10.6h-1.7c-5.8,0-10.6-4.7-10.6-10.6v-78c0-3.3,2.7-6,6-6h10.9h5.8H96c3.3,0,6,2.7,6,6v1.6c0,3.3,2.7,6,6,6   h34.7c3.3,0,6,2.7,6,6v4.8"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  fill: "#C9DAE6",
  cx: 129.9,
  cy: 22,
  r: 3
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  fill: "#C9DAE6",
  cx: 96.9,
  cy: 9.1,
  r: 1.2
});

var _ref8 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#C9DAE6",
  strokeWidth: 3,
  strokeMiterlimit: 10,
  x1: 113.8,
  y1: 11.4,
  x2: 120.7,
  y2: 18.2
});

var _ref9 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#C9DAE6",
  strokeWidth: 3,
  strokeMiterlimit: 10,
  x1: 113.8,
  y1: 18.2,
  x2: 120.6,
  y2: 11.3
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  fill: "#C9DAE6",
  cx: 32.7,
  cy: 85.7,
  r: 3
});

var _ref11 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#C9DAE6",
  strokeWidth: 3,
  strokeMiterlimit: 10,
  x1: 35.7,
  y1: 64.6,
  x2: 42.6,
  y2: 71.4
});

var _ref12 = /*#__PURE__*/React.createElement("line", {
  fill: "none",
  stroke: "#C9DAE6",
  strokeWidth: 3,
  strokeMiterlimit: 10,
  x1: 35.7,
  y1: 71.4,
  x2: 42.5,
  y2: 64.5
});

var SvgEmptyFolderCustomRestore = function SvgEmptyFolderCustomRestore(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 208.6 128",
    style: {
      enableBackground: "new 0 0 208.6 128"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmptyFolderCustomRestore, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/empty_folder_custom_restore.cd58f277.svg";
export { ForwardRef as ReactComponent };